<h2 mat-dialog-title>
  <span class="dialog-title">
    <span class="dialog-title-text">Estado de aprobación</span>
    <span [class]="'status-badge status-badge--' + data.requestable_status">
      {{ data.requestable_status | employeeRequestResponsibleForAnswerStatus }}
    </span>
  </span>
</h2>

<mat-dialog-content>
  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (approvalStatus()) {
    @let status = approvalStatus()!;
    <div class="policy-summary">
      <p class="policy-value">Política: {{ status.approval_policy | employeeRequestApprovalPolicy }}</p>
      <p class="policy-description policy-description--italic">{{ status.policy_description }}</p>
    </div>

    @if (status.responsibles.length > 0) {
      <table mat-table [dataSource]="responsiblesDataSource()" class="responsibles-table">
        <ng-container matColumnDef="responsible">
          <th mat-header-cell *matHeaderCellDef>Responsable</th>
          <td mat-cell *matCellDef="let responsible; dataSource: responsiblesDataSource()">
            <div class="entity-cell">
              <app-user-profile-picture
                [user]="responsible.responsible_user"
                [css_class]="'entity-avatar entity-avatar--user'"
                [alt]="responsible.responsible_user.full_name"
              />
              <span>{{ responsible.responsible_user.full_name }}</span>
            </div>
          </td>
        </ng-container>

        @if (status.approval_policy === EmployeeRequestApprovalPolicyEnum.OnePerProduct) {
          <ng-container matColumnDef="company_product">
            <th mat-header-cell *matHeaderCellDef>Producto</th>
            <td mat-cell *matCellDef="let responsible; dataSource: responsiblesDataSource()">
              @if (responsible.company_product === null) {
                -
              } @else {
                <div class="entity-cell">
                  <img
                    class="entity-avatar entity-avatar--company_product"
                    [src]="responsible.company_product.logo_url"
                    [alt]="responsible.company_product.title"
                  />
                  <span>{{ responsible.company_product.title }}</span>
                </div>
              }
            </td>
          </ng-container>
        }

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let responsible; dataSource: responsiblesDataSource()">
            @if (responsible.should_show_status_as_dash) {
              -
            } @else {
              <span [class]="'status-badge status-badge--' + responsible.status">
                {{ responsible.status | employeeRequestResponsibleForAnswerStatus }}
              </span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="responded_at">
          <th mat-header-cell *matHeaderCellDef>Fecha de respuesta</th>
          <td mat-cell *matCellDef="let responsible; dataSource: responsiblesDataSource()">
            @if (responsible.responded_at) {
              {{ responsible.responded_at | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              -
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
      </table>
    } @else {
      <p class="empty-message">No hay responsables asignados a esta solicitud.</p>
    }
  }
</mat-dialog-content>
